<mat-card appearance="outlined">
    <mat-card-title [innerText]="title | translate" *ngIf="showFirstHalf"></mat-card-title>
    <mat-card-content>
        <form [formGroup]="formGrp" id="newObjekt">
            <ng-container *ngIf="innerWidth <= 1025">
                <div *ngIf="parentObjekt">
                    <mat-form-field style="width:100%" *ngIf="pageCounter === 0">
                        <mat-label>Übergeordnetes Objekt</mat-label>
                        <input matInput type="string" value="{{parentObjekt.objectNumber + ' ' + parentObjekt.description}}" readonly>
                    </mat-form-field>
                </div>

                <app-swiss-dynamic-form *ngFor="let swissField of swissFieldByPage[pageCounter]" [swissField]="swissField" [objectType$]="objectTypeChange$ | async"></app-swiss-dynamic-form>

                <div *ngIf="istKeinAuftrag">
                    <mat-checkbox (change)="onRootLevelChange($event)" [checked]="onRootLevel" [disabled]="!allowChangeRootLevel">Objekt auf oberster Stufe erstellen</mat-checkbox>
                </div>
            </ng-container>


            <ng-container *ngIf="innerWidth > 1025">
                <div *ngIf="parentObjekt">
                    <mat-form-field style="width:100%" *ngIf="pageCounter === 0">
                        <mat-label>Übergeordnetes Objekt</mat-label>
                        <input matInput type="string" value="{{parentObjekt.objectNumber + ' ' + parentObjekt.description}}" readonly>
                    </mat-form-field>
                </div>

                <app-swiss-dynamic-form *ngFor="let swissField of objektDialogResult.swissFields" [swissField]="swissField" [objectType$]="objectTypeChange$ | async"></app-swiss-dynamic-form>

                <div *ngIf="istKeinAuftrag">
                    <mat-checkbox (change)="onRootLevelChange($event)" [checked]="onRootLevel" [disabled]="!allowChangeRootLevel">Objekt auf oberster Stufe erstellen</mat-checkbox>
                </div>
            </ng-container>


        </form>
    </mat-card-content>

    <mat-dialog-actions>
        <button mat-mini-fab matTooltip="{{'MAIN_APP_DIALOG.back' | translate }}" *ngIf="innerWidth < 1025" class="vinavonButton" (click)="prevPart()" [hidden]="pageCounter === 0">
            <mat-icon>arrow_back</mat-icon>
        </button>
        <button (click)="onSubmit()" [disabled]="(blockSaving | async)" [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.save' | translate" class="confirm" mat-stroked-button></button>
        <button mat-stroked-button class="cancel" (click)="onCancel()" [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate"></button>
        <button mat-mini-fab matTooltip="{{'MAIN_APP_DIALOG.forward' | translate }}" *ngIf="innerWidth < 1025" class="vinavonButton" (click)="nextPart()" [hidden]="pageCounter === swissFieldByPage.length - 1">
            <mat-icon>arrow_forward</mat-icon>
        </button>
    </mat-dialog-actions>
</mat-card>
